module.exports = __webpack_public_path__ + "static/media/bitlabs.c9f3dff5.jpg";